import React from 'react';
import { Box } from '@chakra-ui/react';
import { BsChatSquareTextFill } from 'react-icons/bs';

interface CustomFaqIconProps {
  color?: string; // main accent color, e.g. '#07214A'
  size?: string; // optional size prop (e.g. '60px')
}

export const CustomFaqIcon: React.FC<CustomFaqIconProps> = ({ color = 'black', size = '24px' }) => {
  return (
    <Box
      w={size}
      h={size}
      bg={color}
      borderRadius="md"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {/* Speech bubble icon */}
      <Box color="white" fontSize={`calc(${size} * 0.6)`}>
        <BsChatSquareTextFill />
      </Box>
    </Box>
  );
};
